import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg width="24" height="22" viewBox="0 0 24 22" fill="none" {...props}>
    <path
      d="M15 0H7.04644C6.46865 0 6.00004 0.477277 6.00004 1.06578V5.50183H15V0Z"
      fill="#169154"
    />
    <path
      d="M6.00004 16.533V20.9342C6.00004 21.5227 6.46864 22 7.04585 22H15V16.533H6.00004Z"
      fill="#18482A"
    />
    <path d="M6.00004 5.50183H15V11.003H6.00004V5.50183Z" fill="#0C8045" />
    <path d="M6.00004 11.003H15V16.533H6.00004V11.003Z" fill="#17472A" />
    <path
      d="M22.9536 0H15V5.50183H24V1.06578C24 0.477277 23.5314 0 22.9536 0Z"
      fill="#29C27F"
    />
    <path
      d="M15 16.533V22H22.9542C23.5314 22 24 21.5227 24 20.9348V16.5336L15 16.533Z"
      fill="#27663F"
    />
    <path d="M15 5.50183H24L24 11.003H15V5.50183Z" fill="#19AC65" />
    <path d="M15 11.003H24V16.5336L15 16.533V11.003Z" fill="#129652" />
    <path
      d="M10.9914 17.1111H1.0086C0.4518 17.1111 0 16.6509 0 16.0838V5.91617C0 5.34906 0.4518 4.88889 1.0086 4.88889H10.9914C11.5482 4.88889 12 5.34906 12 5.91617V16.0838C12 16.6509 11.5482 17.1111 10.9914 17.1111Z"
      fill="#0C7238"
    />
    <path
      d="M3.484 7.94443H4.9156L6.0772 10.2385L7.3048 7.94443H8.6422L6.7996 11L8.6842 14.0555H7.2736L6.0076 11.6539L4.747 14.0555H3.3154L5.2312 10.989L3.484 7.94443Z"
      fill="white"
    />
  </svg>
);
